/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/explore/explore',['require','jquery','backbone','core/base-screen','screens/explore/explore-collection'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  var Backbone = require('backbone');
  var BaseScreen = require('core/base-screen');
  var ExploreCollection = require('screens/explore/explore-collection');

  /*****************************************************************************************************************///}

  var Explore = BaseScreen.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    events: {
      'click .node': 'nodePressed'
    },
    regions: {
      explore: '.explore-container'
    },
    options: {
      persistentNodes: false
    },

    nodes: [],
    exploreContent: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      ////console.log('Explore::initialize');

      this.nodes = new Backbone.Collection(this.model.get('nodes'));

      this.nodes.each(function(node, index)
      {
        node.set('complete', false);
        node.set('dismissable', true);
        node.set('index', index);
      });
    },

    onShow: function()
    {
      this.playMedia();

      var panel = new ExploreCollection({ collection: this.nodes, persistentNodes: this.options.persistentNodes });
      this.explore.show(panel);
    },

    nodePressed: function(e)
    {
      var nodeEl = $(e.currentTarget);
      var index = nodeEl.attr('data-index');

      var node = this.nodes.at(index);
      node.set('complete', true);

      this.$el.find('.explore-container').show();

      this.$el.find('.node').removeClass('active');
      nodeEl.addClass('active visited');

      this.checkDone();

      if (node.get('media'))
        this.playMedia({ media: node.get('media') });

      this.explore.currentView.activeIndex = index;
      this.explore.currentView.render();

      return false;
    },

    checkDone: function()
    {
      var completed = this.nodes.every('complete');

      if (completed) // all done
        this.finish();
    }

  /*****************************************************************************************************************///}

  });

  return Explore;

});

